import { Component, HostListener } from '@angular/core';
import { CreditSimulatorService } from './services/credit-simulator.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'credit-simulator',
  templateUrl: './credit-simulator.component.html',
  styleUrls: ['./credit-simulator.component.css']
})
export class CreditSimulatorComponent {
  months: number[] = [12, 24, 36];
  selectedMonth: number[] = [12];

  icons = {
    inputCurrency: './assets/icons/money-grey.svg',
    buttonCircle: './assets/icons/button-circle.svg',
    sphere1: './assets/images/sphere-1.png',
  };

  monto: number = 100000;
  helperColor: string = '';
  helperText: string = 'Desde $100,000 hasta $500,000 mxn';

  cotizacion: any = null;
  loading = false;
  error = '';

  constructor(private creditSimulatorService: CreditSimulatorService) { }

  selectMonth(month: number): void {
    this.selectedMonth = [month];
    const colouredSelection = document.querySelector('.coloured-selection') as HTMLElement;
    if (colouredSelection) {
      const index = this.months.indexOf(month);
      const optionWidth = 333 / this.months.length;
      colouredSelection.style.transform = `translateX(${index * optionWidth}%)`;
    }
  }

  onMontoChange() {
    if (this.monto < 100000) {
      this.helperColor = '#ef4444';
      this.helperText = 'El monto mínimo de credito es de $100,000 mxn';
    } else if (this.monto > 500000) {
      this.helperColor = '#ef4444';
      this.helperText = 'El monto máximo de credito es de $500,000 mxn';
    } else if (!/^\d+(\.\d{1,2})?$/.test(this.monto.toString())) {
      this.helperColor = '#ef4444';
      this.helperText = 'Solo se permiten hasta dos decimales';
    } else {
      this.helperColor = '#363636';
      this.helperText = 'Desde $100,000 hasta $500,000 mxn';
    }
  }

  consultarCredito() {
    if (this.monto < 100000 || this.monto > 500000) {
      return;
    }
    this.loading = true;
    this.error = '';
    this.cotizacion = null;
    const amount = Math.floor(this.monto);
    const plazo = this.selectedMonth[0];
    this.creditSimulatorService.getCotizacionInicial(amount, plazo).subscribe({
      next: (res) => {
        this.cotizacion = res.data;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollY = window.scrollY;
    const sphere4 = document.querySelector('.hero-sphere-4') as HTMLElement;
    if (sphere4) sphere4.style.transform = `translateY(${scrollY * 0.25}px)`;
  }
}
